const LINE_NUMBER_DIGITS = 2

/** A line's position, zero-padded to two digits, e.g. `01`. */
export const getImportedInvoiceLineNumber = (lineIndex: number): string =>
  String(lineIndex + 1).padStart(LINE_NUMBER_DIGITS, '0')
